<template>
    <div class="entry-log-panel">
        <div
            class="entry-log-panel__header"
            :class="{
                'entry-log-panel__header--collapsed': collapsed
            }"
        >
            <div
                v-if="!collapsed"
                class="entry-log-panel__title"
            >
                <a-icon type="history" />
                <span>Lịch sử tương tác</span>
            </div>

            <div
                class="entry-log-panel__header-actions"
                :class="{
                    'entry-log-panel__header-actions--collapsed': collapsed
                }"
            >
                <a-badge
                    v-if="Logs.length"
                    :count="Logs.length"
                    :overflow-count="999"
                    :number-style="{
                        backgroundColor: '#1677ff'
                    }"
                />

                <div
                    v-if="collapsed"
                    class="entry-log-panel__collapsed-label"
                    @click="$emit('toggle-collapse')"
                >
                    LỊCH SỬ TƯƠNG TÁC
                </div>

                <a-tooltip
                    :title="
                        collapsed
                            ? 'Mở lịch sử tương tác'
                            : 'Thu gọn lịch sử tương tác'
                    "
                >
                    <a-button
                        type="link"
                        size="small"
                        :icon="
                            collapsed
                                ? 'left'
                                : 'right'
                        "
                        @click="$emit('toggle-collapse')"
                    />
                </a-tooltip>
            </div>
        </div>

        <div
            v-show="!collapsed"
            class="entry-log-panel__scroll"
            @wheel.stop
            @touchmove.stop
        >
            <a-spin :spinning="loading">
                <a-empty v-if="!Logs.length && !loading" description="Chưa có lịch sử tương tác" />

                <a-timeline v-else class="entry-log-timeline">
                    <a-timeline-item v-for="(Log, Index) in Logs" :key="GetLogKey(Log, Index)"
                        :color="GetTimelineColor(Log)">
                        <div class="entry-log-item">
                            <div class="entry-log-item__header">
                                <div class="entry-log-item__action">
                                    {{ GetActionLabel(GetActionCode(Log)) }}
                                </div>

                                <div class="entry-log-item__time">
                                    {{ FormatDateTime(GetLogTime(Log)) }}
                                </div>
                            </div>

                            <div class="entry-log-item__actor">
                                <a-icon type="user" />

                                <span>
                                    {{ GetLogUser(Log) }}
                                </span>
                            </div>

                            <div v-if="GetLogComment(Log)" class="entry-log-item__comment">
                                {{ GetLogComment(Log) }}
                            </div>

                            <div v-if="GetChanges(Log).length" class="entry-log-changes">
                                <button type="button" class="entry-log-changes__toggle" @click="
                                    ToggleChanges(
                                        Log,
                                        Index
                                    )
                                    ">
                                    <span>
                                        <a-icon type="edit" />

                                        {{
                                            GetChanges(Log).length
                                        }}
                                        thay đổi
                                    </span>

                                    <a-icon :type="IsChangesOpen(
                                        Log,
                                        Index
                                    )
                                            ? 'up'
                                            : 'down'
                                        " />
                                </button>

                                <div v-show="IsChangesOpen(
                                    Log,
                                    Index
                                )
                                    " class="entry-log-changes__content">
                                    <div v-for="(
Change,
                                                ChangeIndex
                                        ) in GetChanges(Log)" :key="ChangeIndex" class="entry-log-change">
                                        <div class="entry-log-change__field">
                                            {{
                                                GetFieldLabel(
                                                    Change.Field
                                                )
                                            }}
                                        </div>

                                        <div class="entry-log-change__values">
                                            <code :title="Change.OldValue
                                                ">
                                                {{
                                                    Change.OldValue
                                                }}
                                            </code>

                                            <a-icon type="arrow-right" />

                                            <code :title="Change.NewValue
                                                ">
                                                {{
                                                    Change.NewValue
                                                }}
                                            </code>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a-timeline-item>
                </a-timeline>

                <div v-if="hasMore" class="entry-log-load-more">
                    <a-button size="small" :loading="loading" @click="$emit('load-more')">
                        Tải thêm
                    </a-button>
                </div>
            </a-spin>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'EntryLogPanel',

    props: {
        logs: {
            type: Array,
            default: () => []
        },

        loading: {
            type: Boolean,
            default: false
        },

        hasMore: {
            type: Boolean,
            default: false
        },

        collapsed: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            OpenChangeKeys: {},

            ActionLabels: {
                FillCusInfo:
                    'Điền thông tin khách hàng',

                ChangeCusInfo:
                    'Thay đổi thông tin khách hàng',

                ChangeCodeIMG:
                    'Thay ảnh mã trúng thưởng',

                ChangeCCCDIMG:
                    'Thay ảnh CCCD',

                ConfirmCodeIMG:
                    'Xác nhận ảnh mã trúng thưởng',

                ConfirmCCCDIMG:
                    'Xác nhận ảnh CCCD',

                Pending:
                    'Gửi Supervisor kiểm duyệt',

                Rejected:
                    'Từ chối Entry',

                Verified:
                    'Đã xác minh',

                Re_Review:
                    'Yêu cầu kiểm duyệt lại',

                Approved:
                    'Supervisor duyệt',

                GetVoucher:
                    'Lấy voucher',

                Voucher_Issued:
                    'Lấy voucher thất bại',

                Sent_Voucher:
                    'Gửi voucher đến Zalo KH',

                Sent_Issued:
                    'Gửi voucher thất bại',

                Completed:
                    'Hoàn tất Entry',

                DistributeVoucher:
                    'Phân phối voucher',

                DLR_WAITING:
                    'Voucher đang chờ xác nhận gửi',

                DLR_DELIVERED:
                    'Voucher đã được xác nhận gửi thành công',

                DLR_FAILED:
                    'Voucher gửi thất bại'
            },

            StatusLabels: {
                IN_REVIEW: 'Chờ kiểm duyệt',
                PENDING: 'Chờ Supervisor',
                VERIFIED: 'Đã xác minh',
                RE_REVIEW: 'Kiểm duyệt lại',
                APPROVED: 'Đã duyệt',
                GET_VOUCHER: 'Đang lấy voucher',
                VOUCHER_ISSUED: 'Lấy voucher thất bại',
                SENT_VOUCHER: 'Đã lấy voucher',
                SENT_ISSUED: 'Gửi voucher thất bại',
                COMPLETED: 'Hoàn thành',
                REJECTED: 'Từ chối'
            },

            FieldLabels: {
                Full_Name:
                    'Họ và tên',

                CCCD:
                    'CCCD',

                Address:
                    'Địa chỉ',

                DoB:
                    'Ngày sinh',

                Gender:
                    'Giới tính',

                Note:
                    'Ghi chú',

                Status:
                    'Trạng thái',

                Current_Step:
                    'Bước hiện tại',

                Progress_Step:
                    'Tiến trình',

                Scratch_Code_Image:
                    'Ảnh mã trúng thưởng',

                IsScratch_Code_Image_Verified:
                    'Xác nhận ảnh mã',

                Scratch_Code_Image_Note:
                    'Ghi chú ảnh mã',

                CCCD_Image:
                    'Ảnh CCCD',

                IsCCCD_Image_Verified:
                    'Xác nhận ảnh CCCD',

                CCCD_Image_Note:
                    'Ghi chú ảnh CCCD',

                SuperVisor_Comment:
                    'Nhận xét Supervisor',

                Voucher_Code1: 'Mã voucher 1',
                Voucher_Code2: 'Mã voucher 2',
                Voucher_Status1: 'Trạng thái voucher 1',
                Voucher_Status2: 'Trạng thái voucher 2',
                Voucher_Expiry_Date1: 'Hạn voucher 1',
                Voucher_Expiry_Date2: 'Hạn voucher 2',
                Voucher_Distribution_Request: 'Thời gian yêu cầu gửi',
                Start_Distribution_Time: 'Bắt đầu gửi voucher',
                Voucher_Distribution_Response: 'Thời gian phản hồi gửi',
                Distributed_Time: 'Thời gian hoàn tất gửi',
                IsDistributed: 'Đã phân phối voucher',

                Voucher_Distribution_Response_ID:
                    'Voucher Tracking ID',

                Voucher_Distribution_DLR_Status:
                    'Trạng thái Delivery',

                Voucher_Distribution_DLR_OTT_Status:
                    'OTT status',

                Voucher_Distribution_DLR_Status_Code:
                    'DLR status code',

                Voucher_Distribution_DLR_Error_Code:
                    'Mã lỗi Delivery',

                Voucher_Distribution_DLR_Note:
                    'Ghi chú Delivery',

                Voucher_Distribution_DLR_Source:
                    'Nguồn xác nhận Delivery',

                Voucher_Distribution_DLR_Received_At:
                    'Thời gian nhận DLR',

                Voucher_Distribution_DLR_Delivered_At:
                    'Thời gian Delivery thành công',

                Voucher_Distribution_DLR_Updated_At:
                    'Thời gian cập nhật Delivery',

                Voucher_Distribution_DLR_Checked_At:
                    'Thời gian kiểm tra Timeline',

                Voucher_Distribution_DLR_Timeline_Count:
                    'Số mốc Timeline',

                Voucher_Distribution_DLR_Timeline_Final_Status:
                    'Trạng thái cuối Timeline'
            }
        };
    },

    computed: {
        Logs() {
            return Array.isArray(this.logs)
                ? this.logs
                : [];
        }
    },

    methods: {
        NormalizeKey(Value) {
            return String(Value || '')
                .replace(/[^a-z0-9]/gi, '')
                .toUpperCase();
        },

        GetActionCode(Log) {
            return (
                Log.Action_Code ||
                Log.Event_Code ||
                Log.Modified_Short_Code ||
                Log.Action ||
                Log.Event ||
                Log.Case ||
                ''
            );
        },

        GetActionLabel(Value) {
            const Action = String(
                Value || ''
            ).trim();

            if (!Action) {
                return 'Cập nhật Entry';
            }

            if (this.ActionLabels[Action]) {
                return this.ActionLabels[Action];
            }

            const NormalizedAction =
                this.NormalizeKey(Action);

            const MatchedKey = Object.keys(
                this.ActionLabels
            ).find(
                Key =>
                    this.NormalizeKey(Key) ===
                    NormalizedAction
            );

            if (MatchedKey) {
                return this.ActionLabels[
                    MatchedKey
                ];
            }

            return (
                Action
                    .replace(/_/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim() ||
                'Cập nhật Entry'
            );
        },

        GetFieldLabel(Value) {
            const Field = String(
                Value || ''
            ).trim();

            if (!Field) {
                return '-';
            }

            if (this.FieldLabels[Field]) {
                return this.FieldLabels[
                    Field
                ];
            }

            const NormalizedField =
                this.NormalizeKey(Field);

            const MatchedKey = Object.keys(
                this.FieldLabels
            ).find(
                Key =>
                    this.NormalizeKey(Key) ===
                    NormalizedField
            );

            return MatchedKey
                ? this.FieldLabels[MatchedKey]
                : Field;
        },

        GetLogKey(Log, Index) {
            return String(
                Log._id ||
                Log.Log_ID ||
                Log.ID ||
                Log.Created_At ||
                'LOG_' + Index
            );
        },

        GetLogUser(Log) {
            return (
                Log.Full_Name ||
                Log.Username ||
                Log.Usermame ||
                Log.Last_User ||
                Log.Created_By ||
                Log.User_ID ||
                'Hệ thống'
            );
        },

        GetLogTime(Log) {
            return (
                Log.Created_At ||
                Log.Modified_At ||
                Log.Action_Time ||
                Log.Time ||
                null
            );
        },

        GetLogComment(Log) {
            return String(
                Log.Comment ||
                Log.SuperVisor_Comment ||
                Log.Message ||
                Log.Description ||
                ''
            ).trim();
        },

        GetRawChanges(Log) {
            return (
                Log.Changes ||
                Log.Change_Data ||
                Log.Modified_Data ||
                Log.Fields ||
                []
            );
        },

        GetChanges(Log) {
            let Changes =
                this.GetRawChanges(Log);

            if (!Changes) {
                return [];
            }

            if (
                typeof Changes ===
                'string'
            ) {
                try {
                    Changes =
                        JSON.parse(Changes);
                } catch (Error) {
                    return [];
                }
            }

            if (Array.isArray(Changes)) {
                return Changes.map(
                    Item => ({
                        Field:
                            Item.Field ||
                            Item.Key ||
                            Item.Name ||
                            '-',

                        OldValue:
                            this.FormatValue(
                                Item.OldValue !==
                                    undefined
                                    ? Item.OldValue
                                    : Item.Old
                            ),

                        NewValue:
                            this.FormatValue(
                                Item.NewValue !==
                                    undefined
                                    ? Item.NewValue
                                    : Item.New
                            )
                    })
                );
            }

            if (
                Changes &&
                typeof Changes ===
                'object'
            ) {
                return Object.keys(
                    Changes
                ).map(Field => {
                    const Value =
                        Changes[Field];

                    if (
                        Value &&
                        typeof Value ===
                        'object' &&
                        (
                            Value.OldValue !==
                            undefined ||
                            Value.NewValue !==
                            undefined ||
                            Value.Old !==
                            undefined ||
                            Value.New !==
                            undefined
                        )
                    ) {
                        return {
                            Field: Field,

                            OldValue:
                                this.FormatValue(
                                    Value.OldValue !==
                                        undefined
                                        ? Value.OldValue
                                        : Value.Old
                                ),

                            NewValue:
                                this.FormatValue(
                                    Value.NewValue !==
                                        undefined
                                        ? Value.NewValue
                                        : Value.New
                                )
                        };
                    }

                    return {
                        Field: Field,
                        OldValue: '-',
                        NewValue:
                            this.FormatValue(
                                Value
                            )
                    };
                });
            }

            return [];
        },

        FormatValue(Value) {
            if (
                Value === null ||
                Value === undefined ||
                Value === ''
            ) {
                return '-';
            }

            if (
                typeof Value ===
                'string'
            ) {
                const Status =
                    Value.trim().toUpperCase();

                if (this.StatusLabels[Status]) {
                    return this.StatusLabels[Status];
                }
            }

            if (
                typeof Value ===
                'boolean'
            ) {
                return Value
                    ? 'Có'
                    : 'Không';
            }

            if (
                Value instanceof Date
            ) {
                return moment(Value).format(
                    'DD/MM/YYYY HH:mm:ss'
                );
            }

            if (
                typeof Value ===
                'object'
            ) {
                try {
                    return JSON.stringify(
                        Value
                    );
                } catch (Error) {
                    return String(Value);
                }
            }

            return String(Value);
        },

        ToggleChanges(Log, Index) {
            const Key =
                this.GetLogKey(
                    Log,
                    Index
                );

            this.$set(
                this.OpenChangeKeys,
                Key,
                !this.OpenChangeKeys[Key]
            );
        },

        IsChangesOpen(Log, Index) {
            return (
                this.OpenChangeKeys[
                this.GetLogKey(
                    Log,
                    Index
                )
                ] === true
            );
        },

        FormatDateTime(Value) {
            if (!Value) {
                return '-';
            }

            const DateValue =
                moment(Value);

            return DateValue.isValid()
                ? DateValue.format(
                    'DD/MM/YYYY HH:mm:ss'
                )
                : '-';
        },

        GetChangedStatus(Log) {
            let Changes = this.GetRawChanges(Log);

            if (!Changes) {
                return '';
            }

            if (typeof Changes === 'string') {
                try {
                    Changes = JSON.parse(Changes);
                } catch (Error) {
                    return '';
                }
            }

            if (Array.isArray(Changes)) {
                const Item = Changes.find(
                    Change =>
                        this.NormalizeKey(
                            Change.Field || Change.Key || Change.Name
                        ) === 'STATUS'
                );

                if (!Item) {
                    return '';
                }

                return String(
                    Item.NewValue !== undefined
                        ? Item.NewValue
                        : Item.New !== undefined
                            ? Item.New
                            : ''
                ).trim().toUpperCase();
            }

            if (Changes && typeof Changes === 'object') {
                const Key = Object.keys(Changes).find(
                    Field => this.NormalizeKey(Field) === 'STATUS'
                );

                if (!Key) {
                    return '';
                }

                const Value = Changes[Key];

                if (Value && typeof Value === 'object') {
                    return String(
                        Value.NewValue !== undefined
                            ? Value.NewValue
                            : Value.New !== undefined
                                ? Value.New
                                : ''
                    ).trim().toUpperCase();
                }

                return String(Value || '').trim().toUpperCase();
            }

            return '';
        },

        GetTimelineColor(Log) {
            const Status = this.GetChangedStatus(Log);
            const StatusColors = {
                IN_REVIEW: 'blue',
                PENDING: 'gold',
                VERIFIED: 'cyan',
                RE_REVIEW: 'orange',
                APPROVED: 'purple',
                GET_VOUCHER: 'geekblue',
                VOUCHER_ISSUED: 'volcano',
                SENT_VOUCHER: 'blue',
                SENT_ISSUED: 'magenta',
                COMPLETED: 'green',
                REJECTED: 'red'
            };

            if (StatusColors[Status]) {
                return StatusColors[Status];
            }

            const Action = this.NormalizeKey(this.GetActionCode(Log));

            if (Action === 'COMPLETED') return 'green';
            if (Action === 'APPROVED') return 'purple';
            if (Action === 'GETVOUCHER') return 'geekblue';
            if (Action === 'VOUCHERISSUED') return 'volcano';
            if (Action === 'SENTVOUCHER') return 'blue';
            if (Action === 'SENTISSUED') return 'magenta';
            if (Action === 'REJECTED') return 'red';
            if (Action === 'REREVIEW') return 'orange';
            if (Action === 'PENDING') return 'gold';
            if (Action === 'VERIFIED') return 'cyan';

            return 'blue';
        }
    }
};
</script>

<style scoped>
.entry-log-panel {
    display: grid;
    grid-template-rows:
        auto minmax(0, 1fr);
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    background: #fff;
}
/* .entry-log-panel {
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow: hidden;
} */

.entry-log-panel__scroll {
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-gutter: stable;
    -webkit-overflow-scrolling: touch;
}

.entry-log-panel__header {
    display: flex;
    min-height: 42px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 12px;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
}

.entry-log-panel__title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
}

.entry-log-panel__header-actions {
    display: flex;
    align-items: center;
    gap: 5px;
}

.entry-log-panel__header-actions .ant-btn {
    padding: 0 5px;
}

.entry-log-panel__header--collapsed {
    min-height: 100%;
    height: 100%;
    padding: 8px 4px;
    align-items: flex-start;
    justify-content: center;
    border-bottom: 0;
}

.entry-log-panel__header-actions--collapsed {
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    gap: 8px;
}

.entry-log-panel__header-actions--collapsed .ant-btn {
    width: 30px;
    height: 30px;
    padding: 0;
    font-size: 15px;
}

.entry-log-panel__collapsed-label {
    writing-mode: vertical-rl;

    margin-top: 4px;

    color: rgba(0, 0, 0, 0.72);
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0.8px;
    line-height: 1.1;

    white-space: nowrap;
    cursor: pointer;
    user-select: none;
}

.entry-log-panel__collapsed-label:hover {
    color: #1677ff;
}

.entry-log-panel__header-actions--collapsed ::v-deep .ant-badge {
    margin-top: 2px;
}

.entry-log-panel__scroll {
    min-height: 0;
    padding: 12px 10px 16px;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-gutter: stable;
}

.entry-log-timeline {
    padding-top: 2px;
}

.entry-log-item {
    min-width: 0;
    padding-bottom: 4px;
}

.entry-log-item__header {
    display: flex;
    min-width: 0;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
}

.entry-log-item__action {
    min-width: 0;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.85);
    font-size: 12px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.entry-log-item__time {
    flex: 0 0 auto;
    color: rgba(0, 0, 0, 0.38);
    font-size: 10px;
    white-space: nowrap;
}

.entry-log-item__actor {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;
    color: rgba(0, 0, 0, 0.5);
    font-size: 10px;
}

.entry-log-item__comment {
    padding: 6px 8px;
    margin-top: 6px;
    background: #fffbe6;
    border-left: 3px solid #faad14;
    color: rgba(0, 0, 0, 0.72);
    font-size: 11px;
    line-height: 1.45;
    white-space: pre-wrap;
}

.entry-log-changes {
    margin-top: 6px;
    overflow: hidden;
    border: 1px solid #f0f0f0;
    border-radius: 3px;
}

.entry-log-changes__toggle {
    display: flex;
    width: 100%;
    min-height: 29px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 8px;
    background: #fafafa;
    border: 0;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.62);
    font-size: 11px;
    text-align: left;
}

.entry-log-changes__toggle:hover {
    background: #f0f5ff;
}

.entry-log-changes__toggle span {
    display: flex;
    align-items: center;
    gap: 5px;
}

.entry-log-changes__content {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 4px 8px;
    background: #fff;
    border-top: 1px solid #f0f0f0;
}

.entry-log-change {
    padding: 6px 0;
    border-bottom: 1px dashed #f0f0f0;
}

.entry-log-change:last-child {
    border-bottom: 0;
}

.entry-log-change__field {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, 0.58);
    font-size: 10px;
    font-weight: 600;
}

.entry-log-change__values {
    display: grid;
    grid-template-columns:
        minmax(0, 1fr) 14px minmax(0, 1fr);
    align-items: center;
    gap: 4px;
}

.entry-log-change__values code {
    display: block;
    min-width: 0;
    padding: 3px 5px;
    overflow: hidden;
    background: #f5f5f5;
    color: rgba(0, 0, 0, 0.68);
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.entry-log-load-more {
    padding: 8px 0 2px;
    text-align: center;
}

.entry-log-panel::v-deep .ant-timeline-item-tail {
    border-left-color: #e8e8e8;
}

.entry-log-panel::v-deep .ant-empty {
    margin: 30px 0;
}
</style>
